const logger = require("@/utils/logger");
const namespaceService = require("@/utils/namespace-api");
const tokenService = require("@/utils/token-api");
const router = require("@/router");
const config = require("config");

const HOUR_IN_SECONDS = 60 * 60
const DAY_IN_SECONDS = HOUR_IN_SECONDS * 24

const ExpirationOptions = [
  {
    label: '5 minutes',
    expiration: 5*60
  }, {
    label: '1 hour',
    expiration: HOUR_IN_SECONDS
  }, {
    label: '1 day',
    expiration: DAY_IN_SECONDS
  }, {
    label: '7 days',
    expiration: 7*DAY_IN_SECONDS
  }, {
    label: '30 days',
    expiration: 30*DAY_IN_SECONDS
  }, {
    label: '100 days',
    expiration: 100*DAY_IN_SECONDS
  }
]

export default {
  data: function () {
    return {
      token: "",
      existingNamespace: null,
      newNamespace: null,
      createNewNamespace: false,
      namespaces: null,
      expiration: DAY_IN_SECONDS,
      tokenref: "",
      expirationOptions: ExpirationOptions
    }
  },
  methods: {
    onClickToken() {
      // doesn't work for safari?
      if (this.$refs.tokenref.select) this.$refs.tokenref.select();
    },
    getSelectedNamespace() {
      return this.createNewNamespace ? this.newNamespace : this.existingNamespace;
    },
    loadNamespaces() {
      namespaceService.list().then(namespaces => {
        this.namespaces = namespaces;
        const hasExistingNamespaces = this.namespaces.length > 0;
        this.createNewNamespace = !hasExistingNamespaces;
        if (hasExistingNamespaces) {
          this.existingNamespace = this.namespaces[0].namespace;
          logger.log("selected " + this.existingNamespace);
        }
      });
    },
    getExpiration() {
      return this.expiration
    },
    validate_expiration(expirationSeconds) {
      if (this.expiration < config.token_expiration_min_seconds) {
        return false
      }
      if (this.expiration > config.token_expiration_max_seconds) {
        return false
      }
      return true
    },
    generateToken() {
      const namespace = this.getSelectedNamespace()
      logger.log('Creating token for namespace [' + namespace + ']')

      if (!namespaceService.isValid(namespace)) return

      if (!this.validate_expiration(this.expiration)) {
        alert('Invalid token expiration.')
        return
      }

      tokenService
        .generateToken(namespace, this.expiration)
        .then(token => {
          this.token = token;
        })
        .catch(err => {
          console.error(err);
          alert(err);
        });
    }
  },
  mounted() {
    this.loadNamespaces();
  }
};



// WEBPACK FOOTER //
// ./src/utils/generate-token-mixin.js